import { Navigate, useLocation } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useAuthStore } from '@/store/auth.store'

interface Props {
  children: React.ReactNode
}

/**
 * Read-only do auth store. NÃO toca em status nem dispara queries.
 * O AuthBootstrap é quem hidrata e mantém o status atualizado.
 */
export function ProtectedRoute({ children }: Props) {
  const location = useLocation()
  const { user, status } = useAuthStore()

  // status='idle' = ainda nem começou a checar
  // status='loading' = não usamos mais, mas mantém compat
  if (status === 'idle' || status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-app">
        <Loader2 className="h-6 w-6 animate-spin text-fg-3" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}
